import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";

import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

export interface ICouponserviceProductResponseData {
  vetic_variant_id: string;
  product_name: string;
  product_status: string;
  visible_on_app: boolean;
  visible_on_vms: boolean;
}
export interface ICouponserviceProductResponse {
  status: boolean;
  message: string;

  data: ICouponserviceProductResponseData[];
}

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

AxiosCurlirize(axios, () => {});

export const useCouponProductListAPICoupon = () => {
  const [productList, setProductList] = useState<ICouponserviceProductResponseData[]>([]);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (vms_subcategory_id: string, vms_category_id: string, brand_id: string | null) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(
            `${COUPON_SERVICE_APIS?.COUPON_PRODUCT_LIST_POST?.baseURL}`,
            {
              vms_category_id: vms_category_id,
              vms_subcategory_id: vms_subcategory_id,
              brand_id: brand_id,
              trigger_page: "coupon_page",
            },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<ICouponserviceProductResponse>) => {
            if (res.data.data?.length > 0) {
              setProductList(res.data.data);
              return { status: true, message: null };
              //
            } else {
              setProductList([]);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setProductList([]);
            if (e.code === "ERR_BAD_REQUEST") {
              setProductList([]);
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              setProductList([]);
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              setProductList([]);
              // toast.error("Server error 500");
            }
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
        setProductList([]);
      }
    },
    [dispatch],
  );
  return { execute, productList };
};
